/**
 * 08.10.26 — панель Telegram Client справочника каналов.
 * Не удалять по требованию владельца системы.
 */
import { Input } from '@/components/ui';
import type { ChannelPanelProps } from '../channelPanelProps';
import { ChannelFieldLabel, ChannelLink } from './ChannelLink';

export function TelegramClientPanel({ form, isSuperAdmin, onChange }: ChannelPanelProps) {
  if (isSuperAdmin) {
    return (
      <Input
        label="Ссылка на аккаунт"
        value={form.telegram_client_url || ''}
        onChange={(event) => onChange({ telegram_client_url: event.target.value })}
        placeholder="https://t.me/clinic_account"
        testId="input-telegram-client-url"
      />
    );
  }

  return (
    <div>
      <ChannelFieldLabel>Ссылка</ChannelFieldLabel>
      <div className="mt-1">
        <ChannelLink href={form.telegram_client_url} emptyText="Ссылка на контактный Telegram пока не указана" />
      </div>
    </div>
  );
}
